import { 
    HEALTHCARE_VENDOR_STATS_FAIL, 
    HEALTHCARE_VENDOR_STATS_REQUEST, 
    HEALTHCARE_VENDOR_STATS_SUCCESS 
} from "../constants/webOrderConstants";

const initialState = {
    stats: {
        newOrders: 0,
        pendingDelivery: 0,
        delivered: 0,
        assigned: 0,
        paymentMethods: {},
    },
    loading: false,
    error: null,
};

export const healthcareVendorStatsReducer = (state = initialState, action) => {
    switch (action.type) {
        case HEALTHCARE_VENDOR_STATS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null, // Reset error when making a new request
            };
        case HEALTHCARE_VENDOR_STATS_SUCCESS:
            return {
                ...state,
                loading: false,
                stats: action.payload,
            };
        case HEALTHCARE_VENDOR_STATS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

